var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.getIsLoadingVolumeDetails)?[(_vm.hasVolumeDetails)?[_c('volume-details',{staticClass:"mt-10 mt-sm-2",attrs:{"volume-details":_vm.getVolumeDetails,"separacaoValue":_vm.separacaoValue},on:{"finalizarPedido":_vm.finalizarPedido,"gerarSeparacao":_vm.gerarSeparacao}})]:_vm._e()]:_c('default-spinner')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }